'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function IndexPage() {
  const router = useRouter()

  useEffect(() => {
    const destination = localStorage.getItem('session') ? '/us/browse' : '/en/welcome'
    router.replace(destination)
  }, [router])

  // The root launch experience remains visible while this route resolves.
  return null
}
